/* tslint:disable */
import { OutputData } from "./OutputData"

export class Decision {
		Id: number;
		Name: string;
		DecisionServiceVersionId: number;
		DecisionServiceId: number;
		VersionNumber: number;
		StepId: number;
		BusinessDataIds: string;
		BusinessMetaDataIds: string;
		FormatResult: string;
		ShowInStep: boolean;
		ShowInSummary: boolean;

		OutputData: OutputData[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Decision.ts